import * as Yup from 'yup'

const loginSchema = Yup.object({
  identifier: Yup.string().email('Insira um e-mail válido').required('O e-mail é obrigatório'),
  password: Yup.string().required('Insira sua senha')
})

export default loginSchema
